<template>
  <div>
    <base-box :title="baseTitle">
      <v-container grid-list-md>
        <div ref="Top"></div>
        <v-layout row
                  wrap>
          <v-flex @click="testFunc"
                  style="max-width: 80px;">
            <sub-header class="required"><template v-slot:title>簽名人員</template>
            </sub-header>
          </v-flex>
          <v-flex>
            <v-layout row
                      wrap>
              <v-flex sm3
                      class="link-finger"
                      :key="key"
                      v-for="(item, key) in uiSignList"
                      @click="changeSigner(item)">
                <sign-time sign-doen
                           :active="isSignerActive(item)"
                           :signer="item.signer"
                           :signature-time="item.signTime"></sign-time>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row
                  wrap
                  style="margin-top:20px">
          <v-flex style="max-width: 80px;">
            <sub-header class="required"><template v-slot:title>簽名位置</template>
            </sub-header>
          </v-flex>
          <v-flex xs10
                  lg11>
            <v-layout row
                      wrap>
              <v-flex sm3
                      class="link-finger sign"
                      v-for="(item, key) in uiSignLocationList"
                      :key="key"
                      :class="isSignLocationActive(item)"
                      @click="changeSignLocation(item)">
                <sign-icon style="vertical-align: bottom;"
                           :done="checkIsDone(item)"></sign-icon>
                {{item.caption}}
              </v-flex>
              <v-flex sm3
                      v-if="showNextSignLocation()">
                <btn-info :disabled="disableNextSignLocation()"
                          @click="nextSignLocation">下一個簽名位置</btn-info>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
          <div>
            <v-layout>
              <v-flex :key="key"
                      v-show="item.isShow"
                      v-for="(item, key) in pdfSrcList">
                <pdf-viewer-with-image :key="key"
                            style="position: relative;"
                            :src="getPdfSrc(item)"
                            :cfgRatio="pdfViewerRatio"
                            :usedMaskLoading="true"
                            :id="item.fid">
                  <div slot="signBlockList"
                       class="signBlock"
                       :key="key+ '_' + key2"
                       v-for="(r, key2) in signLocationListfilterByFid(item.fid)"
                       :style="signBlockStyle(r)"
                       :id="getBlockId(item.fid , r)"
                       @click="clickToSign(item.fid , r)">
                    <div v-html="r.showText"></div>
                  </div>
                </pdf-viewer-with-image>
              </v-flex>
              <v-btn  dark  color="amber" style="border-radius: 50%;position: fixed;bottom: 20px;right: 30px;min-width: 70px;height: 70px" @click="goRef('Top')" >
                  TOP
                </v-btn>
              <v-btn v-for="(item, index) in floatButtonkList"  :key="'floatButtonk_' + index" dark outlined  :color="item.color" :style="getFloatButtonStyle(item,index)" style="font-size:22px" @click="floatButtonClickHandle(item)" >
                {{item.text}}
              </v-btn>

            </v-layout>
          </div>
        <v-dialog v-model="dialog"
                  fullscreen
                  persistent>
          <base-dialog style="margin-top:-70px">
            <template v-slot:title>
              <div class="signDialogTitleStyle"><span style="font-size: 50px;color: red">{{signDialogTitle}}</span><span style="font-size: 40px;">簽名</span>
                <v-btn icon
                       @click="dialog = false"
                       style="float: right;margin-top: -2px;">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:content>
              <div class="sign-bg">
                <signature :signature-for="customerSignature"
                           :cfg-data="signDialogCfg"
                           ref="signaturePadPanel"
                           @signed="saveSignature"
                           v-model="signatureData"></signature>
              </div>
            </template>
            <template v-slot:btn>
              <div>
                <btn-lg-primary @click.native="toSave">確認</btn-lg-primary>
              </div>
            </template>
          </base-dialog>
        </v-dialog>
      </v-container>
    </base-box>
    <base-btn>
      <!-- isShowPreViewStep 為了提供觸發機制 -->
      <btn-info v-if="!isShowPreViewStep && showNextSignLocation()"
                :disabled="disableNextSignLocation()"
                @click="nextSignLocation">下一個簽名位置</btn-info>
      <!-- <btn-lg-primary v-if="isShowPreViewStep"
                      @click="preViewStepHandler">下一步</btn-lg-primary> -->
    </base-btn>
  </div>
</template>
<script>
import SignTime from '@/components/Base/SignTime'
import SignIcon from '@/components/Base/SvgIcon/SignIcon'
import PdfViewerWithImage from '@/components/PDFViewer/PDFViewerWithImage'
import { dateFormatString, withDebounce } from '@/utils'
import { createNamespacedHelpers } from 'vuex'
import Signature from './Signature'
const { mapActions } = createNamespacedHelpers('ins')
const Combinded = '|'
export default {
  name: 'policy-signature',
  components: {
    SignIcon,
    SignTime,
    Signature,
    PdfViewerWithImage
  },
  data () {
    return {
      dialog: false,
      polrecS02List: [],
      polsS01Map: {},
      signS01List: [],
      uiSignList: [], // 簽名人員清單列表
      uiSignLocationList: [], // 簽名文件清單列表
      uiSignOtherLocationMap: {},
      uiSignOtherLocationIndex: 0,
      signRelaData: {},
      pdfSrcList: [],
      baseTitle: '要保書簽名(客戶)',
      customerSignature: '要保人簽名簽名板',
      signatureData: null,
      clickSignEl: null,
      clickSignItemData: null,
      signDialogTitle: '要保人',
      signDialogCfg: { signHint1: null, signHint2: null },
      showNextSignBtn: false,
      activeSigner: null, // 目前簽名人員身分
      activeSignLocation: null, // 目前簽名文件位置
      nextActiveSigner: null, // 下一個簽名人員身分(有尚未簽名的)
      nextActiveSignLocation: null, // 下一個簽名文件(有尚未簽名的)
      colNameMapSignCode: {},
      signCodeCountNum: {},
      allNeedSignCount: 0,
      signCheck: true,
      pdfSrcListForSignatureFinish: [],
      docListByShowOrder: [], // 文件清單根據顯示順序紀錄
      floatButtonkList: [], // 簽名畫面中右下角之浮動按鈕清單
      checkPdfShowReadyTimes: 0
    }
  },
  props: {
    transCode: {
      type: String
    },
    parentTitle: {
      type: String
    },
    isPreview: {
      // 是否為檢視模式
      type: Boolean,
      default: false
    },
    changeYn: {
      type: String
    },
    signedYn: {
      type: String
    }
  },
  mounted () {
    this.getPreViewList()
  },
  computed: {
    isShowPreViewStep () {
      // fix by Bug #35661，【業務員簽名】功能下的預覽還是要判斷是否簽名完成
      const { isPreview } = this
      if (isPreview) {
        return false
      }

      // 檢核 『合計應簽名數量』=『合計已簽名數量』時，顯示此按鈕
      let {
        signatureData,
        signRelaData,
        polsS01Map,
        colNameMapSignCode
      } = this
      let hadUnSign = 0
      if (signatureData) {
        // 此處僅是為了讓此函數可監控 signatureData 的異動後觸發
        hadUnSign = 0
      }
      let hadChkSignRelaData = false
      if (signRelaData) {
        for (let signRelaKey in signRelaData) {
          let colName = signRelaKey
          let isGroupSignCont = colName === 'GROUP_SIGN_CONT'
          if (signRelaData[colName] && colNameMapSignCode[colName]) {
            // let otherSignCode = colNameMapSignCode[colName]

            let signItemValue = signRelaData[colName]
            // 此處於每次簽名完成後都會觸發，故額外檢查是否該填入完成日期
            signItemValue.layouts.forEach(r => {
              let key =
                r.docCode +
                Combinded +
                r.signCode +
                Combinded +
                r.singRefCusCode
              let signCont = polsS01Map[key]
              if (
                isGroupSignCont ||
                signCont ||
                (r.showText && r.showText.indexOf('<img src=') > -1)
              ) {
              } else {
                // 找出尚未簽名的資料
                hadUnSign += 1
              }
            })
            hadChkSignRelaData = true
          }
        }
      }

      if (hadUnSign > 0 ) {
        this.$emit('signed-handler', '')
        return false
      } else if(hadChkSignRelaData){
        // 已完成所有簽名位置
        this.$emit('signed-handler', 'Finished')
        return true
      }else {
        this.$emit('signed-handler', '')
        return false
      }
    },
    is1024Size () {
      if (window.screen.width < 1366) {
        return true
      } else {
        return false
      }
    },
    pdfViewerRatio () {
      if (this.is1024Size) {
        return '0.84'
      } else {
        return '1.2'
      }
    },
    pdfViewerCSS () {
      if (this.is1024Size) {
        return 'width1024'
      } else {
        return 'width1366'
      }
    },
    pageHeightOffset () {
      if (this.is1024Size) {
        return 1353
      } else {
        return 1351
      }
    },
    elementHeightOffset () {
      if (this.is1024Size) {
        return 12
      } else {
        return 25
      }
    }
  },
  beforeDestroy () {
    const ios = navigator.userAgent.indexOf('ipad')
    if (ios) {
      document.body.removeEventListener('touchmove', this.pp, { passive: false })
    }
  },
  watch: {
    dialog (v) {
      const ios = navigator.userAgent.indexOf('ipad')
      if (ios) {
        if (v) {
          document.body.addEventListener('touchmove', this.pp, { passive: false })
        } else {
          document.body.removeEventListener('touchmove', this.pp, { passive: false })
        }
      }
    }
  },
  methods: {
    goRef (v) {
      const options = { ...{ block: 'start' } }
      this.$refs[v].scrollIntoView(options)
    },
    pp (e) {
      e.preventDefault()
      // const el = document.querySelector('#signature-pad')
      // if (e.srcElement.tagName === 'DIV') {
      // }
    },
    reInitHandle () {
      // 重新初始化與載入套印資料
      this.getPreViewList()
    },
    claerPDFViewer () {
      this.pdfSrcList.splice(0)
    },
    countSignNums (colName, colNameMapSignCode, signCodeCountNum) {
      // 計算此份文件需要簽名的數量
      let signCode01 = colNameMapSignCode[colName + '_1']
      let signCode02 = colNameMapSignCode[colName + '_2']
      let signCode03 = colNameMapSignCode[colName + '_3']
      // add by SCR #45415, 增加 OWNER_SIGN_CONT_4 , LEGAL_SIGN_CONT_4
      let signCode04 = colNameMapSignCode[colName + '_4']
      let signCodeAGREE = colNameMapSignCode[colName + '_AGREE']
      let signCodeMainKind = colNameMapSignCode[colName + '_MAIN_F']
      let numList = [
        signCodeCountNum[signCode01],
        signCodeCountNum[signCode02],
        signCodeCountNum[signCode03],
        signCodeCountNum[signCode04],
        signCodeCountNum[signCodeAGREE],
        signCodeCountNum[signCodeMainKind]
      ]
      let nn = 0
      for (let k = 0; k < numList.length; k++) {
        if (numList[k] && numList[k] > 0) {
          nn += numList[k]
        }
      }
      if (nn < 1) {
        nn = 1
      }
      return nn
    },
    getPreViewList () {
      // 載入清單資料
      this.signCodeCountNum = {}
      this.hadFinish = false
      let {
        transCode,
        polrecS02List,
        signS01List,
        uiSignList,
        signCodeCountNum,
        docListByShowOrder
      } = this
      let self = this
      polrecS02List.splice(0)
      signS01List.splice(0)
      uiSignList.splice(0)
      docListByShowOrder.splice(0)
      let isAgentSign = 'N'
      this.customerSignature = '要保人簽名簽名板'
      this.signDialogTitle = '要保人'
      this.baseTitle = '要保書簽名(客戶)'
      this.$api
        .get('pdfreport/com/preViewList', {
          params: {
            transCode: transCode,
            isAgentSign: isAgentSign
          }
        })
        .then(r => {
          if (r.data) {
            let Srv1 = r.data.polrecS02
            if (Srv1) {
              // Srv1
              Srv1.forEach(r => {
                if (!docListByShowOrder.includes(r.docCode)) {
                  docListByShowOrder.push(r.docCode)
                }
                polrecS02List.push(r)
              })
            }
            if (r.data.polsS01) {
              // Srv2
              this.polsS01Map = r.data.polsS01
            }
            if (r.data.signRelaData) {
              this.signRelaData = r.data.signRelaData
              let sumSignTotal = 0
              for (let k in this.signRelaData) {
                // k: 簽署者 , v: 對應的簽署相關資料
                let v = this.signRelaData[k]
                let colName = k
                this.colNameMapSignCode[k] = v.signCode
                let num = 1
                if (v.layouts) {
                  num = v.layouts.length
                }
                if (colName === 'GROUP_SIGN_CONT') {
                  // 集彙團體主成員，不須計算
                  continue
                }
                if (signCodeCountNum[v.signCode]) {
                  signCodeCountNum[v.signCode] += num
                } else {
                  signCodeCountNum[v.signCode] = num
                }
              }
              for (let keyValue in signCodeCountNum) {
                sumSignTotal += signCodeCountNum[keyValue]
              }
              self.allNeedSignCount = sumSignTotal
            }
            if (r.data.signS01) {
              // Srv3
              let keepOnlyOne = {}
              r.data.signS01.forEach(r => {
                let signName = r.signName
                let colName = r.colname
                let cusCode = r.cusCode // 簽署者對應的客戶代碼，有可能為空值
                let signCount = 1
                // 若欄位資料已被排除，則不需在此處理
                if (!this.signRelaData[colName]) return
                // add by SCR #45415, 增加 OWNER_SIGN_CONT_4 , LEGAL_SIGN_CONT_4
                if (
                  colName.endsWith('_1') ||
                  colName.endsWith('_2') ||
                  colName.endsWith('_3') ||
                  colName.endsWith('_4') ||
                  colName.endsWith('_AGREE') ||
                  colName.endsWith('_MAIN_F')
                ) {
                  let ii = signName.lastIndexOf('_')
                  if (ii > -1) {
                    signName = signName.substring(0, ii)
                  }
                  let gpColName = colName
                  ii = colName.lastIndexOf('_')
                  if (ii > -1) {
                    gpColName = colName.substring(0, ii)
                  }
                  // 有可能需要簽名多處，檢核
                  signCount = this.countSignNums(
                    gpColName,
                    this.colNameMapSignCode,
                    signCodeCountNum
                  )
                }
                // 除了重複顯示的問題外，並處理時間欄位的呈現(時間最新的資料)
                let curItem = {
                  signer: signName,
                  signTime: r.signDt,
                  colname: colName,
                  signCode: r.signCode,
                  cusCode: cusCode,
                  isActive: false
                }
                if (!keepOnlyOne[signName]) {
                  // 將重複的資料僅放一筆
                  if (curItem.signTime) {
                    curItem.signTime = self.changeDateFormat(curItem.signTime)
                  }
                  uiSignList.push(curItem)
                  keepOnlyOne[signName] = curItem
                } else {
                  let showItem = keepOnlyOne[signName]
                  // 若需要有多筆簽名，簽名時間必須都要有值，才可顯示
                  if (r.signDt) {
                    if (!showItem.signTime) {
                      if (signCount > 1) {
                        showItem.signTime = null
                      } else {
                        showItem.signTime = self.changeDateFormat(r.signDt)
                      }
                    } else {
                      if (r.signDt > showItem.signTime) {
                        showItem.signTime = self.changeDateFormat(r.signDt)
                      }
                    }
                  } else {
                    showItem.signTime = null
                  }
                }
              })
              Array.prototype.push.apply(signS01List, r.data.signS01)
            }
            if (uiSignList && uiSignList.length > 0) {
              self.changeSigner(uiSignList[0])
            }

            // 下載 PDF 套印檔案
            self.downloadPreviePdf()
          }
        })
    },
    changeSigner (item) {
      // 切換簽名人員身分，每個文件只要呈現一項(除了法定代理人)
      let self = this
      this.uiSignOtherLocationMap = {}
      this.uiSignOtherLocationIndex = 0
      this.activeSigner = item
      this.activeSignLocation = null
      let {
        uiSignLocationList,
        uiSignList,
        polsS01Map,
        uiSignOtherLocationMap,
        signRelaData,
        colNameMapSignCode,
        docListByShowOrder
      } = this
      // 清空簽名位置清單
      uiSignLocationList.splice(0) // 某指定簽屬者，對應的需要簽屬文件清單
      let colName = item.colname
      let changeSignerDefaultDoc = null
      if (colName && this.signRelaData) {
        let signer = item.signer
        this.signDialogTitle = signer
        // let signCode = item.signCode
        let listSignKey = []
        // add by SCR #45415, 增加 OWNER_SIGN_CONT_4 , LEGAL_SIGN_CONT_4
        if (
          colName.endsWith('_1') ||
          colName.endsWith('_2') ||
          colName.endsWith('_3') ||
          colName.endsWith('_4') ||
          colName.endsWith('_AGREE') ||
          colName.endsWith('_MAIN_F')
        ) {
          let prfixSignKey = colName.substring(0, colName.lastIndexOf('_'))
          // listSignKey.push(colName)
          listSignKey.push(prfixSignKey + '_1')
          listSignKey.push(prfixSignKey + '_2')
          listSignKey.push(prfixSignKey + '_3')
          // add by SCR #45415, 增加 OWNER_SIGN_CONT_4 , LEGAL_SIGN_CONT_4
          listSignKey.push(prfixSignKey + '_4')
          listSignKey.push(prfixSignKey + '_AGREE')
          listSignKey.push(prfixSignKey + '_MAIN_F')
        } else {
          listSignKey.push(colName)
        }

        let tempUiSignLocationMap = {} // 暫存紀錄，待後續依據排序才逐一放入陣列中
        for (let ii = 0; ii < listSignKey.length; ii++) {
          let sk = listSignKey[ii] // 簽屬者 (欄位名稱)
          if (signRelaData[sk] && colNameMapSignCode[sk]) {
            // let otherSignCode = colNameMapSignCode[sk]
            let signItemValue = signRelaData[sk]
            signItemValue.layouts.forEach(r => {
              let key =
                r.docCode +
                Combinded +
                r.signCode +
                Combinded +
                r.singRefCusCode
              let signCont = polsS01Map[key]
              let fid = r.docFid + Combinded + r.singRefCusCode
              if (signCont && !r.showText) {
                let wNew = r.layoutItem.width * (this.pdfViewerRatio / 1.2)
                let hNew = r.layoutItem.height * (this.pdfViewerRatio / 1.2)
                r.showText = this.imgData(signCont, wNew, hNew) // signCont
              }
              let locationItem = {
                caption: r.docName,
                docCode: r.docCode,
                fid: fid,
                srcColName: r.srcColName,
                recCode: r.recCode,
                showText: r.showText,
                belongPageNum: r.layoutItem.belongPageNum,
                layoutItem: r.layoutItem,
                isActive: false,
                signer: signer,
                signTime: '',
                signCode: r.signCode,
                refSignRelaItem: r
              }
              if (!uiSignOtherLocationMap[fid]) {
                uiSignOtherLocationMap[fid] = []
              }
              if (!tempUiSignLocationMap[r.docCode]) {
                tempUiSignLocationMap[r.docCode] = []
              }
              tempUiSignLocationMap[r.docCode].push(locationItem)
              uiSignOtherLocationMap[fid].push(locationItem)
            })
          }
        }
        // 根據文件排序，逐一將簽名位置紀錄於陣列中
        let hadAddDocCodeList = []
        docListByShowOrder.forEach(docCode => {
          if (tempUiSignLocationMap[docCode]) {
            let list = tempUiSignLocationMap[docCode]
            list.forEach(r => {
              if (!changeSignerDefaultDoc) {
                // 預設切換簽屬者後的第一個
                changeSignerDefaultDoc = r
              }
              let needBreak = false
              if (hadAddDocCodeList.includes(docCode)) {
                // 文件已加入
                needBreak = true
                // 若是法代欄位且為問卷文件，則允許多份
                let srcColName = r.refSignRelaItem.srcColName
                let queFlag = r.refSignRelaItem.queFlag
                let isShareCol = false
                if (
                  srcColName.startsWith('AGENT1_SIGN_CONT') ||
                  srcColName.startsWith('AGENT2_SIGN_CONT') ||
                  srcColName.startsWith('LEGAL_SIGN_CONT')
                ) {
                  isShareCol = true
                }
                if (isShareCol && queFlag === 'QUE') {
                  needBreak = false
                }
              }
              if (needBreak) {
                return
              }
              uiSignLocationList.push(r)
              hadAddDocCodeList.push(docCode)
            })
          }
        })
      }
      uiSignList.forEach(r => {
        r.isActive = false
      })
      item.isActive = true
      if (changeSignerDefaultDoc) {
        setTimeout(function () {
          self.changeSignLocation(changeSignerDefaultDoc)
        }, 300)
      }
    },
    signLocationListfilterByFid (fid) {
      // 處理單一文件中需要簽名處
      let { uiSignLocationList, uiSignOtherLocationMap } = this
      let list = []
      if (uiSignLocationList) {
        let combindedList = []
        Array.prototype.push.apply(combindedList, uiSignLocationList)
        if (uiSignOtherLocationMap && uiSignOtherLocationMap[fid]) {
          for (let n = 1; n < uiSignOtherLocationMap[fid].length; n++) {
            let otherR = uiSignOtherLocationMap[fid][n]
            combindedList.push(otherR)
          }
        }
        let isViewOnly = this.isPreview
        // 合併多筆可能簽名位置
        combindedList.forEach(r => {
          let showText = '請點擊我簽名'
          if (isViewOnly) {
            showText = ''
          }
          if (r.fid === fid) {
            if (!r.showText) {
              if (
                r.layoutItem &&
                r.srcColName &&
                r.srcColName.endsWith('_AGREE')
              ) {
                if (isViewOnly) {
                  showText = ''
                } else {
                  showText = '請點擊我輸入'
                }
              }
              r.showText = showText
            }
            list.push(r)
          }
        })
      }
      return list
    },
    changeSignLocation (item) {
      // 切換簽名位置，即切換PDF文件意思
      if (item && item.layoutItem) {
        let clickSignLocItem = item
        if (this.uiSignOtherLocationMap[item.fid]) {
          let list = this.uiSignOtherLocationMap[item.fid]
          if (list.length > 1) {
            for (let ii = 0; ii < list.length; ii++) {
              let r = list[ii]
              if (!r.showText || r.showText.indexOf('<img src=') === -1) {
                // 尚未被簽名
                this.uiSignOtherLocationIndex = ii
                item = r
                break
              }
            }
          }
        }

        this.activeSignLocation = item
        let idStr = item.fid + '_' + item.layoutItem.columnId
        let singRefCusCode = item.refSignRelaItem.singRefCusCode
        let colName = item.srcColName

        this.pdfSrcList.forEach(r => {
          if (r.fid === item.fid) {
            if (
              colName &&
              (colName.startsWith('AGENT1_SIGN_CONT') ||
                colName.startsWith('AGENT2_SIGN_CONT'))
            ) {
              r.isShow = true
            } else {
              let isShareCol = false
              if (
                colName.startsWith('AGENT1_SIGN_CONT') ||
                colName.startsWith('AGENT2_SIGN_CONT') ||
                colName.startsWith('LEGAL_SIGN_CONT')
              ) {
                isShareCol = true
              }
              if (singRefCusCode) {
                // --若是問卷，需要額外考慮，判斷 singRefCusCode
                if (singRefCusCode === r.cusCode || isShareCol) {
                  r.isShow = true
                } else {
                  r.isShow = false
                }
              } else {
                r.isShow = true
              }
            }
          } else {
            r.isShow = false
          }
        })
        this.showSignBlockEl(idStr)

        this.uiSignLocationList.forEach(r => {
          r.isActive = false
        })
        clickSignLocItem.isActive = true
        this.triggerAfterSignAction()// 觸發浮動按鈕建置判讀
      }
    },
    checkIsDone (item) {
      // 判斷文件中是否都已經簽名完畢
      if (item && item.layoutItem) {
        if (
          this.uiSignOtherLocationMap[item.fid] &&
          this.uiSignOtherLocationMap[item.fid].length > 0
        ) {
          let list = this.uiSignOtherLocationMap[item.fid]
          for (let ii = 0; ii < list.length; ii++) {
            let r = list[ii]
            if (!r.showText || r.showText.indexOf('<img src=') === -1) {
              // 尚未被簽名
              return false
            }
          }
          return true
        }
      }
      return false
    },
    showSignBlockEl (idStr) {
      let el = document.getElementById(idStr)
      if (el) {
        const self = this
        self.checkPdfShowReadyTimes = 0
        setTimeout(function () {
          el.scrollIntoView({ block: 'center', inline: 'nearest' })
          self.checkPdfShowReady(el)// fix by Issue #34754
        }, 300)
      }
    },
    checkPdfShowReady (el) { // fix by Issue #34754，加上額外等候等待畫面結束後再重新呼叫簽名框呈現
      const self = this
      let waitEl = document.querySelector('div.loading')
      if (waitEl) {
        if (waitEl.style.display !== 'none' && self.checkPdfShowReadyTimes < 20) {
          self.checkPdfShowReadyTimes += 1
          setTimeout(function () {
            self.checkPdfShowReady(el)
          }, 500)
        } else {
          el.scrollIntoView({ block: 'center', inline: 'nearest' })
        }
      }
    },
    downloadPreviePdf () {
      // 下載 PDF 套印檔案
      let { transCode, polrecS02List, pdfSrcList } = this
      pdfSrcList.splice(0)
      let  isAgentSign = 'Y'
      if (polrecS02List) {
        let jj = 0
        polrecS02List.forEach(r => {
          let cusCode = r.cusCode
          if (r.docFid) {
            let fid = r.docFid + Combinded + cusCode
            let pCusCode = cusCode || '' //--避免參數回傳後, 變成 null 字串!
            let url = `pdfreport/com/preViewPdf?transCode=${transCode}&docFid=${r.docFid}&cusCode=${pCusCode}`
            let item = {
              docB: '',
              fid: fid,
              transCode: transCode,
              cusCode: cusCode,
              isShow: false,
              srcUrl: url,
              isAgentSign: isAgentSign
            }
            if (jj === 0) {
              // 第一筆
              item.isShow = true
            }
            pdfSrcList.push(item)
            jj++
          }
        })
      }
    },
    getPdfSrc (item) {
      const defaultBlank = 'pdfreport/com/preViewPdf?transCode=_blank'
      if (item) {
        if (item.isShow) {
          item.docB = item.srcUrl
        } else {
          item.docB = defaultBlank
        }
        if (item.docB) {
          return item.docB
        }
      }
      return defaultBlank
    },
    signBlockStyle (item) {
      // 繪製簽名區塊 element 在畫上\
      let HeightOffset = this.elementHeightOffset // (cfg.height / 2)
      if (item && item.layoutItem) {
        let cfg = item.layoutItem
        let pageNum = cfg.belongPageNum
        let pdfContainerHeigh = 0
        if (pageNum) {
          // 每頁 偏移高度 1351
          // pdfContainerHeigh = (pageNum - 1) * this.pageHeightOffset
          pdfContainerHeigh = (pageNum - 1) * this.pageHeightOffset
          // pdfContainerHeigh = pdfContainerHeigh * (this.pdfViewerRatio / 1.2)
        }
        let top = cfg.y + pdfContainerHeigh
        if (this.is1024Size && pageNum === 1) {
          HeightOffset = HeightOffset + 10
        }
        top =
          parseFloat(top) * parseFloat(this.pdfViewerRatio / 1.2) -
          HeightOffset
        let borderStyle = ''
        if (this.isPreview) {
          borderStyle = 'border: none;'
        }
        let heightEl = cfg.height * (this.pdfViewerRatio / 1.2)
        let widthEl = cfg.width * (this.pdfViewerRatio / 1.2)
        let xEl = cfg.x * (this.pdfViewerRatio / 1.2)
        return `top:${top}px;left:${xEl}px;width:${widthEl}px;height:${heightEl}px;line-height:${heightEl}px;${borderStyle}`
      }
      return ''
    },
    getBlockId (fid, item) {
      if (item && item.layoutItem) {
        return fid + '_' + item.layoutItem.columnId
      }
      return ''
    },
    saveSignature (data) {
      if (this.isPreview) return
      this.signatureData = data
    },
    toSave () {
      if (this.isPreview) return
      this.$refs.signaturePadPanel.saveSignature()
      let signEl = this.clickSignEl
      let signItem = this.clickSignItemData
      let signLocationList = this.uiSignLocationList
      let locationMap = this.uiSignOtherLocationMap

      if (signEl) {
        if (this.signatureData) {
          let w = signEl.offsetWidth
          let h = signEl.offsetHeight
          signItem.showText =
            '<img src="' +
            this.signatureData +
            '" width="' +
            w +
            'px" height="' +
            h +
            'px" />'
        } else {
          signItem.showText = null
        }
        signItem.refSignRelaItem.showText = signItem.showText // 回寫回原本物件資料
        // signEl.innerHTML = '<img src="' + this.signatureData + '" width="' + w + 'px" height="' + h + 'px" />'
      }
      if (this.signatureData) {
        signItem.signTime = new Date()
        let needSignCount = this.signCodeCountNum[signItem.signCode]
        signItem.needSignCount = needSignCount
      }
      // --this.signatureData == null 表示刪除
      this.updateSignature(signItem)
      if (signEl) {
        // let item = this.activeSignLocation
        let hasFinish = false
        if (this.signatureData) {
          hasFinish = true
          this.insStepHandler({ progClassName: 'signature_confirm', methodName: '確定', stepCode: 'INS_S8' })
        }
        if (signLocationList) {
          signLocationList.forEach(sL => {
            if (locationMap[sL.fid]) {
              let list = locationMap[sL.fid]
              for (let ii = 0; ii < list.length; ii++) {
                let r = list[ii]
                if (!r.showText || r.showText.indexOf('<img src=') === -1) {
                  // 尚未被簽名
                  hasFinish = false
                  break
                }
              }
            }
          })
        }
        if (this.activeSigner) {
          if (hasFinish) {
            this.activeSigner.signTime = dateFormatString(
              new Date(),
              'yyyy/MM/dd hh:mm'
            )
          } else {
            this.activeSigner.signTime = ''
          }
        }
        // signItem.signTime = dateFormatString(new Date(), 'yyyy-MM-dd hh:mm')
      }
      this.dialog = false
      this.clickSignEl = null
    },
    updateSignature (signItem) {
      if (this.isPreview) return
      let { recCode, signCode, signTime, needSignCount } = signItem
      // var dataURL = signaturePad.toDataURL() //--轉成 PNG 圖檔 Base64 編碼資料
      let contentType = '' // 無簽名資料
      if (this.signatureData) {
        let parts = this.signatureData.split(';base64,')
        contentType = parts[1]
      } else {
        let key =
          signItem.docCode +
          Combinded +
          signCode +
          Combinded +
          signItem.refSignRelaItem.singRefCusCode
        this.polsS01Map[key] = null
      }
      let isAgentSign = 'Y'
      // 若無簽名資料，送回更新則表示清除簽名資料
      let param = { signatureImageBase64: contentType }
      param.transCode = this.transCode
      param.recCode = recCode
      param.signCode = signCode
      param.cusCode = signItem.refSignRelaItem.singRefCusCode
      param.needSignCount = needSignCount
      param.allNeedSignCount = this.allNeedSignCount
      param.signDt = this.formatDate(signTime)
      param.signerName = signItem.signer
      param.colName = signItem.srcColName
      param.isAgentSign = isAgentSign
      // 送回簽名圖檔串流資料
      this.$api.post('pdfreport/com/updateSignature', param)
      this.triggerAfterSignAction()
    },
    onScroll (e) {
      // this.offsetTopA = e.target.scrollTop
    },
    goBack () {
      this.$emit('click')
    },
    editDataHandler () {
      const self = this
      let msgText = ''
      let goTabStr = ''
      msgText = '「提醒您! 此按鈕為修改投保資料，若您已簽名，簽名字樣會全部清空，謝謝」'
      goTabStr = 'go-ins-s1-tab'
      self.$confirm(msgText, yn => {
        if (yn) {
          // 處理資料是否異動旗標，並導向要保人頁簽
          self.$emit('set-change')
          self.$emit(goTabStr)
        }
      })
    },
    preStepHandler () {
      this.$emit('pre-tab')
    },
    preViewStepHandler: withDebounce(function () {
      // 預覽文件，需確認簽名齊全
      let self = this
      if (this.isPreview) {
        self.callFinishAction()
        return
      }

      if (this.isShowPreViewStep) {
        let param = { transCode: this.transCode ,allNeedSignCount: self.allNeedSignCount }
        self.pdfSrcListForSignatureFinish.splice(0)
        // 預覽文件呼叫
        this.$api.post('/pdfreport/com/updateToPreview', param).then(r => {
          let { successMsg, errMsg } = r.data
          if (successMsg) {
            self.$alert(successMsg, yn => {
              self.callFinishAction()
            })
          } else if (errMsg) {
            this.$alert(errMsg)
          } else {
            self.callFinishAction()
          }
        })
      }
    }),
    callFinishAction () {
       //fix: Issue #83809, Issue #83807 , 移除此呼叫
      // 執行預覽呼叫，改為執行下一步
      // let self = this
      // self.$emit('next-tab')
    },
    clickToSign (fid, item) {
      // 點選簽名框，準備簽名板
      if (this.isPreview) return
      this.clickSignEl = null
      if (item && item.layoutItem) {
        this.clickSignItemData = item
        let idStr = fid + '_' + item.layoutItem.columnId
        let el = document.getElementById(idStr)
        if (el) {
          this.clickSignEl = el
        }
        if (item.srcColName.endsWith('_AGREE')) {
          this.signDialogCfg.signHint1 = ' '
          this.signDialogCfg.signHint2 = '請親自書寫正楷「同意投保」字樣'
          this.signDialogTitle = '請親自書寫「同意投保」字樣於下方空白處'
        } else {
          this.signDialogCfg.signHint1 = ''
          this.signDialogCfg.signHint2 = ''
          this.signDialogTitle = item.signer
        }
      }
      this.signatureData = ''
      this.dialog = true
    },
    isSignerActive (item) {
      // 簽名人員
      if (item && item.isActive) {
        return true
      }
      return false
    },
    isSignLocationActive (item) {
      // 簽名位置
      if (item && item.isActive) {
        return 'active'
      }
      return ''
    },
    testFunc () {
      // 測試功能
      // window.open('RestApi/public/testCompleteToOnePdf')
    },
    formatDate (d) {
      if (d) {
        return dateFormatString(d, 'yyyy-MM-dd hh:mm:ss.S') // 此處為上傳的時間格式請勿更換
      }
      return ''
    },
    changeDateFormat (d) {
      let fixDate = d
      if (d && d.indexOf('-') > -1) {
        fixDate = d.replace(/-/g, '/')
      }

      // 轉為民國年處理
      if (fixDate) {
        let ayDate = fixDate.split('/')
        if (ayDate.length > 1) {
          let yyyy = parseInt(ayDate[0])
          if (yyyy && yyyy > 1911) {
            ayDate[0] = '' + (yyyy - 1911)
            fixDate = ayDate.join('/')
          }
        }
      }
      return fixDate
    },
    imgData (base64Str, w, h) {
      /*
      const { isPreview } = this
      if (isPreview) {
        return ''
      }
      */
      if (base64Str) {
        return (
          '<img src="data:image/png;base64,' +
          base64Str +
          ' "width="' +
          w +
          'px" height="' +
          h +
          'px"  />'
        )
      }
      return ''
    },
    showNextSignLocation () {
      // 是否顯示【下一個按鈕】
      if (this.activeSignLocation) {
        let item = this.activeSignLocation
        if (
          this.uiSignOtherLocationMap[item.fid] &&
          this.uiSignOtherLocationMap[item.fid].length > 1
        ) {
          return true
        }
      }
      return false
    },
    disableNextSignLocation () {
      // 【下一個按鈕】是否為禁止狀態
      if (this.isPreview) return true
      if (this.activeSignLocation) {
        let item = this.activeSignLocation
        if (
          this.uiSignOtherLocationMap[item.fid] &&
          this.uiSignOtherLocationMap[item.fid].length > 1
        ) {
          let list = this.uiSignOtherLocationMap[item.fid]
          if (list.length > 1) {
            for (let ii = 0; ii < list.length; ii++) {
              let r = list[ii]
              if (!r.showText || r.showText.indexOf('<img src=') === -1) {
                // 尚未被簽名
                return false
              }
            }
          }
        }
      }
      return true
    },
    nextSignLocation () {
      // 點選，下一個
      if (this.activeSignLocation) {
        let item = this.activeSignLocation
        if (
          this.uiSignOtherLocationMap[item.fid] &&
          this.uiSignOtherLocationMap[item.fid].length > 1
        ) {
          let list = this.uiSignOtherLocationMap[item.fid]

          // SCR #23653 僅跳到尚未簽名處
          let hadCheckUnSigned = false
          let nextIndex = 0
          for (let ii = 0; ii < list.length; ii++) {
            let stepIndex = this.uiSignOtherLocationIndex + (1 + ii)
            if (list.length <= stepIndex) {
              nextIndex = stepIndex - list.length
            } else {
              nextIndex = stepIndex
            }
            let chkItem = list[nextIndex]
            if (
              chkItem.showText &&
              chkItem.showText.indexOf('<img src=') > -1
            ) {
              // 若已經有簽名資訊，跳過
              continue
            } else {
              hadCheckUnSigned = true
            }
            if (hadCheckUnSigned) {
              break
            }
          }
          if (hadCheckUnSigned) {
            item = list[nextIndex]
            let idStr = item.fid + '_' + item.layoutItem.columnId
            this.showSignBlockEl(idStr)
            this.activeSignLocation = item
            this.uiSignOtherLocationIndex = nextIndex
          }
        }
      }
    },
    destoryHandler () {
      // 上傳完畢後，會呼叫 destory 事件
      this.$emit('destory', true)
    },
    insStepHandler ({ progClassName, methodName, stepCode }) {
      // save access log
      this.$store
        .dispatch('common/postUserAccessLog', {
          transCode: this.transCode,
          actionMsg: '',
          progClassName: progClassName,
          methodName: methodName,
          sysType: 'F',
          stepCode: stepCode
        })
        .then(r => {})
    },
    triggerAfterSignAction () { // 簽名確認後觸發
      this.nextActiveSigner = null // 下一個簽名人員身分(有尚未簽名的)
      this.nextActiveSignLocation = null // 下一個簽名文件(有尚未簽名的)
      // 檢核簽名位置是否還有待簽名
      let hadUnSignBlock = false
      let hadTwoSignBlock = false
      if (this.activeSignLocation) {
        let item = this.activeSignLocation
        let result = this.doCheckUnSignBlock(item, this.uiSignOtherLocationMap, this.uiSignOtherLocationIndex)
        hadUnSignBlock = result.hadUnSignBlock
        hadTwoSignBlock = result.hadTwoSignBlock
      }
      if (hadUnSignBlock) {
        if (hadTwoSignBlock) {//
          this.buildFloatButtons(3)
        } else {
          this.buildFloatButtons(4)
        }
        return
      }
      //1:下一個人員 , 2:下一個文件 ,3:下一個簽名 ,4:請繼續簽名
      // 檢核文件清單是否還有未簽名
      let uiSignLocationList = this.uiSignLocationList
      let rtDoc = this.doCheckUnSignDoc(uiSignLocationList, this.activeSignLocation, this.uiSignOtherLocationMap)
      this.nextActiveSignLocation = rtDoc.nextActiveSignLocation
      let hadNetxDoc = rtDoc.hadNetxDoc
      if (hadNetxDoc) {//下一份文件
        this.buildFloatButtons(2)
        return
      }
      // 檢核簽名者是否還有未簽名
      let uiSignList = this.uiSignList
      let rtSigner = this.doCheckUnSignSinger(uiSignList, this.activeSigner)
      this.nextActiveSigner = rtSigner.nextActiveSigner
      let hadNetxSigner = rtSigner.hadNetxSigner
      if (hadNetxSigner) {//下一個簽名人員
        this.buildFloatButtons(1)
        return
      }
      // 若以上都檢核過，此處應該可呈現預覽文件
      //this.buildFloatButtons(1)
    },
    doCheckUnSignBlock (item, uiSignOtherLocationMap, uiSignOtherLocationIndex) { // 檢核文件中是否有尚未簽名的區塊與是否有兩個以上的簽名
      let result = { hadUnSignBlock: false, hadTwoSignBlock: false }
      let list = uiSignOtherLocationMap[item.fid]
      if (
        list &&
          list.length > 0
      ) {
        let hadCheckUnSigned = false
        let nextIndex = 0
        if (list.length > 1) {
          result.hadTwoSignBlock = true
        }
        if (uiSignOtherLocationIndex < 0) {
          uiSignOtherLocationIndex = -1
        }
        for (let ii = 0; ii < list.length; ii++) {
          let stepIndex = uiSignOtherLocationIndex + (1 + ii)
          if (list.length <= stepIndex) {
            nextIndex = stepIndex - list.length
          } else {
            nextIndex = stepIndex
          }
          let chkItem = list[nextIndex]
          if (!chkItem) continue
          if (
            chkItem.showText &&
              chkItem.showText.indexOf('<img src=') > -1
          ) {
            // 若已經有簽名資訊，跳過
            continue
          } else {
            hadCheckUnSigned = true
          }
          if (hadCheckUnSigned) {
            break
          }
        }
        if (hadCheckUnSigned) {
          item = list[nextIndex]
          result.hadUnSignBlock = true
        } else {
          result.hadUnSignBlock = false
        }
      }
      return result
    },
    doCheckUnSignDoc (uiSignLocationList, activeSignLocation, uiSignOtherLocationMap) { // 檢核此簽名者的清單文件中，是否還有未簽名的
      let result = { hadNetxDoc: false, nextActiveSignLocation: null }
      if (uiSignLocationList) {
        let docLen = uiSignLocationList.length
        let docCureentIndex = -2
        if (activeSignLocation) {
          for (let j = 0; j < docLen; j++) {
            let chkItem = uiSignLocationList[j]
            if (chkItem && chkItem.fid === activeSignLocation.fid) {
              docCureentIndex = j
            }
          }
        } else {
          docCureentIndex = -1
        }
        if (docCureentIndex > -2) {
          let endLoopIndex = docCureentIndex + docLen
          if (docCureentIndex === -1) {
            endLoopIndex = docCureentIndex + docLen + 1
          }
          // 從 docCureentIndex 迴圈執行 docLen 次數
          for (let k = docCureentIndex + 1; k < endLoopIndex; k++) {
            let indJ = k
            if (indJ >= docLen) {
              indJ = indJ - docLen
            }
            let chkItem = uiSignLocationList[indJ]
            let rt = this.doCheckUnSignBlock(chkItem, uiSignOtherLocationMap, -1)
            if (rt.hadUnSignBlock) {
              result.hadNetxDoc = true
              result.nextActiveSignLocation = chkItem
              break
            }
          }
        }
      }
      return result
    },
    getDocListFromSigner (signerItem) {
      let result = { uiSignLocationList: [], uiSignOtherLocationMap: {} }
      let {
        polsS01Map,
        signRelaData,
        colNameMapSignCode,
        docListByShowOrder
      } = this
      let colName = signerItem.colname
      let changeSignerDefaultDoc = null
      if (colName && this.signRelaData) {
        let signer = signerItem.signer
        let listSignKey = []
        // add by SCR #45415, 增加 OWNER_SIGN_CONT_4 , LEGAL_SIGN_CONT_4
        if (
          colName.endsWith('_1') ||
          colName.endsWith('_2') ||
          colName.endsWith('_3') ||
          colName.endsWith('_4') ||
          colName.endsWith('_AGREE') ||
          colName.endsWith('_MAIN_F')
        ) {
          let prfixSignKey = colName.substring(0, colName.lastIndexOf('_'))
          listSignKey.push(prfixSignKey + '_1')
          listSignKey.push(prfixSignKey + '_2')
          listSignKey.push(prfixSignKey + '_3')
          // add by SCR #45415, 增加 OWNER_SIGN_CONT_4 , LEGAL_SIGN_CONT_4
          listSignKey.push(prfixSignKey + '_4')
          listSignKey.push(prfixSignKey + '_AGREE')
          listSignKey.push(prfixSignKey + '_MAIN_F')
        } else {
          listSignKey.push(colName)
        }

        let tempUiSignLocationMap = {} // 暫存紀錄，待後續依據排序才逐一放入陣列中
        for (let ii = 0; ii < listSignKey.length; ii++) {
          let sk = listSignKey[ii] // 簽屬者 (欄位名稱)
          if (signRelaData[sk] && colNameMapSignCode[sk]) {
            let signItemValue = signRelaData[sk]
            signItemValue.layouts.forEach(r => {
              let key =
                r.docCode +
                Combinded +
                r.signCode +
                Combinded +
                r.singRefCusCode
              let signCont = polsS01Map[key]
              let fid = r.docFid + Combinded + r.singRefCusCode
              if (signCont && !r.showText) {
                let wNew = r.layoutItem.width * (this.pdfViewerRatio / 1.2)
                let hNew = r.layoutItem.height * (this.pdfViewerRatio / 1.2)
                r.showText = this.imgData(signCont, wNew, hNew) // signCont
              }
              let locationItem = {
                caption: r.docName,
                docCode: r.docCode,
                fid: fid,
                srcColName: r.srcColName,
                recCode: r.recCode,
                showText: r.showText,
                belongPageNum: r.layoutItem.belongPageNum,
                layoutItem: r.layoutItem,
                isActive: false,
                signer: signer,
                signTime: '',
                signCode: r.signCode,
                refSignRelaItem: r
              }
              if (!result.uiSignOtherLocationMap[fid]) {
                result.uiSignOtherLocationMap[fid] = []
              }
              if (!tempUiSignLocationMap[r.docCode]) {
                tempUiSignLocationMap[r.docCode] = []
              }
              tempUiSignLocationMap[r.docCode].push(locationItem)
              result.uiSignOtherLocationMap[fid].push(locationItem)
            })
          }
        }
        // 根據文件排序，逐一將簽名位置紀錄於陣列中
        let hadAddDocCodeList = []
        docListByShowOrder.forEach(docCode => {
          if (tempUiSignLocationMap[docCode]) {
            let list = tempUiSignLocationMap[docCode]
            list.forEach(r => {
              if (!changeSignerDefaultDoc) {
                // 預設切換簽屬者後的第一個
                changeSignerDefaultDoc = r
              }
              let needBreak = false
              if (hadAddDocCodeList.includes(docCode)) {
                // 文件已加入
                needBreak = true
                // 若是法代欄位且為問卷文件，則允許多份
                let srcColName = r.refSignRelaItem.srcColName
                let queFlag = r.refSignRelaItem.queFlag
                let isShareCol = false
                if (
                  srcColName.startsWith('AGENT1_SIGN_CONT') ||
                  srcColName.startsWith('AGENT2_SIGN_CONT') ||
                  srcColName.startsWith('LEGAL_SIGN_CONT')
                ) {
                  isShareCol = true
                }
                if (isShareCol && queFlag === 'QUE') {
                  needBreak = false
                }
              }
              if (needBreak) {
                return
              }
              result.uiSignLocationList.push(r)
              hadAddDocCodeList.push(docCode)
            })
          }
        })
      }
      return result
    },
    doCheckUnSignSinger (uiSignList, activeSigner) { // 檢核簽名者中，是否還有未簽名的簽名人員
      let result = { hadNetxSigner: false, nextActiveSigner: null }
      if (uiSignList) {
        let singerCount = uiSignList.length
        let signerCureentIndex = -1
        for (let j = 0; j < singerCount; j++) {
          let chkItem = uiSignList[j]
          if (activeSigner && chkItem.colname === activeSigner.colname) {
            signerCureentIndex = j
          }
        }
        if (signerCureentIndex > -1) {
        // 從 signerCureentIndex 迴圈執行 singerCount 次數
          for (let k = signerCureentIndex + 1; k < signerCureentIndex + singerCount; k++) {
            let indJ = k
            if (indJ >= singerCount) {
              indJ = indJ - singerCount
            }
            let chkItem = uiSignList[indJ]
            let rtSigner = this.getDocListFromSigner(chkItem)
            let rt = this.doCheckUnSignDoc(rtSigner.uiSignLocationList, null, rtSigner.uiSignOtherLocationMap)
            if (rt.hadNetxDoc) {
              this.nextActiveSignLocation = rt.nextActiveSignLocation
              result.hadNetxSigner = true
              result.nextActiveSigner = chkItem
              break
            }
          }
        }
      }
      return result
    },
    buildFloatButtons (showIndex) { // 根據不同情境，建立浮動按鈕狀態
      // --按鈕位置建立由下往上增加 bottom，所以順序必須要顛倒
      // 浮動按鈕建置 0:下一個人員 , 1:下一個文件 ,2:下一個簽名 ,3:請繼續簽名
      const defaultFloatButtonkList = [
        { text: '下一個人員', handleType: 'netxSigner', isShow: false, color: 'red' },
        { text: '下一個文件', handleType: 'netxDoc', isShow: false, color: 'primary' },
        { text: '下一個簽名', handleType: 'netxSignBlock', isShow: false, color: 'primary' },
        { text: '請繼續簽名', handleType: 'goBackSignBlock', isShow: false, color: 'primary' }
      ]
      let hadSetIndex = false
      if (showIndex && showIndex > 0 && showIndex < defaultFloatButtonkList.length) {
        defaultFloatButtonkList[showIndex - 1].isShow = true
        hadSetIndex = true
      }
      let floatButtonkList = []
      let hadItemShow = false
      for (let j = 0; j < defaultFloatButtonkList.length; j++) {
        let item = defaultFloatButtonkList[j]
        if (item.handleType === 'netxSignBlock') {
          if (!hadSetIndex) {
            if (this.disableNextSignLocation()) {
              item.isShow = false
            } else {
              item.isShow = true
            }
          }
        } else if (item.handleType === 'goBackSignBlock') {
          if (hadItemShow) { // 若有任一個已經是顯示狀態，則不需要有此按鈕
            item.isShow = false
          }
        }
        if (item.isShow) {
          hadItemShow = true
          floatButtonkList.push(item)
        }
      }
      this.floatButtonkList = floatButtonkList
    },
    getFloatButtonStyle (item, index) { // 取得浮動按鈕的樣式
    // --按鈕位置建立由下往上增加 bottom
      let bottomVal = 100 + index * 50
      let bottomStr = '' + bottomVal
      return `position: fixed;bottom: ${bottomStr}px;right: 10px`
    },
    floatButtonClickHandle (item) { // 設定浮動按鈕 click 觸發事件
      const { handleType } = item
      if (handleType === 'netxSignBlock') { // 下一個簽名
        this.nextSignLocation()
      } else if (handleType === 'goBackSignBlock') { // 請繼續簽名
        this.doGoBackSignBlockAction()
      } else if (handleType === 'netxDoc') { // 下一個文件
        this.doNetxDocAction()
      } else if (handleType === 'netxSigner') { // 下一個人員
        this.doNetxSignerAction()
      }
    },
    doGoBackSignBlockAction () { // 執行呼叫 請繼續簽名
      if (this.activeSignLocation) {
        this.changeSignLocation(this.activeSignLocation)
      }
    },
    doNetxDocAction () { // 執行呼叫 下一個文件
      if (this.nextActiveSignLocation) {
        this.changeSignLocation(this.nextActiveSignLocation)
      }
    },
    doNetxSignerAction () { // 執行呼叫 下一個人員
      let self = this
      if (self.nextActiveSigner) {
        self.changeSigner(self.nextActiveSigner)
        if (self.nextActiveSignLocation) {
          setTimeout(() => {
            this.changeSignLocation(self.nextActiveSignLocation)
          }, 300)
        }
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
canvas {
  width: 100%;
  height: 350px;
  margin: 10px 10px 10px 10px;
  border: 2px solid #b5aeae;
}
div.canvasContainerCss img {
  width: 100%;
  height: 350px;
  margin: 10px 10px 10px 10px;
  border: 2px solid #b5aeae;
}
.sign-bg {
  background-color: #f8f8f8;
  padding: 20px;
  padding-bottom:0px
}

.sign-box {
  border: 5px solid #eee;
  cursor: pointer;
  height: 150px;
  width: 150px;
}

.sign-box.active {
  border: 5px solid red;
  border-radius: 5px 5px 0px 0px;
}

.link-finger {
  cursor: pointer;
}

.signBlock {
  cursor: pointer;
  border: 1px solid red;
  position: absolute;
  font-size: 18px;
  font-weight: bolder;
  color: red;
  text-align: center;
}

.sign.active {
  color: #FFF;
  font-weight: 700;
  font-size: 16px;
  background: #f26f28;
  border-radius: 5px 5px 0px 0px;
  border: 2px solid #f26f28;
}

.scroll-view.width1024 {
  height: 930px;
}

.scroll-view.width1366 {
  height: 1310px;
}
.signDialogTitleStyle {
  user-select: none;
}
</style>
